import { DropdownResponse } from "./dropdown.model";

export interface DropdownState {
    data: DropdownResponse | null;
    loading: boolean;
    error: boolean;
    errorMessage: string | null;
  }
  
  export const dropdownInitialState: DropdownState = {
    data: null,
    loading: false,
    error: false,
    errorMessage: null,
  };